module.exports = __webpack_public_path__ + "img/電気回路_4_6_5.830c7d62.png";